import { useState } from 'react';
import { Box, Button, Menu, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import JobForm from './job/JobForm';
import CandidateForm from './candidate/CandidateForm';
import ClientForm from './client/ClientForm';
import notify from 'lib/notify';
import router from 'next/router';

const QuickAdd = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const [selectedItem, setSelectedItem] = useState<string | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (success: boolean = false) => {
    setAnchorEl(null);
    setSelectedItem(null);

    if (success) {
      notify('Added successfully');
    }
  };

  const handleItemClick = (item: string) => {
    handleClose();
    setSelectedItem(item);
  };

  const renderSelectedItem = () => {
    if (!selectedItem) return null;

    if (selectedItem === 'job')
      return (
        <JobForm
          open={true}
          onClose={() => handleClose()}
          onSuccess={response => {
            handleClose(true);
            if (response?._id) {
              router.push(`/job?id=${response._id}`);
            }
          }}
        />
      );

    if (selectedItem === 'candidate')
      return (
        <CandidateForm
          open={true}
          onClose={() => handleClose()}
          onSuccess={response => {
            handleClose(true);

            if (response?._id) {
              router.push(`/candidate?id=${response._id}`);
            }
          }}
        />
      );

    if (selectedItem === 'client')
      return (
        <ClientForm
          open={true}
          onClose={() => handleClose()}
          onSuccess={response => {
            handleClose(true);
            if (response?._id) {
              router.push(`/client?id=${response._id}`);
            }
          }}
        />
      );
  };

  return (
    <>
      {renderSelectedItem()}

      <Button
        color="secondary"
        aria-controls={open ? 'quick-add-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        variant="outlined"
        onClick={handleClick}
        sx={theme => ({
          backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
          border: 'none',
          px: 1.5,
          color: 'text.primary',
          mr: 1,
        })}
      >
        <AddIcon fontSize="small" sx={{ mr: 0.5 }} />
        Add
        <Box sx={{ ml: 0.5, height: '20px', width: '18px', display: 'flex', alignItems: 'center' }}>
          <ExpandMoreIcon fontSize="small" />
        </Box>
      </Button>

      <Menu
        id="quick-add-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose()}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <MenuItem onClick={() => handleItemClick('job')}>Job</MenuItem>
        <MenuItem onClick={() => handleItemClick('candidate')}>Candidate</MenuItem>
        <MenuItem onClick={() => handleItemClick('client')}>Client</MenuItem>
      </Menu>
    </>
  );
};

export default QuickAdd;
